import { mapStatuses } from "@helpers/liveFloor";
import React from "react";
import { Button, Label } from "semantic-ui-react";

const StatusLabels = (props) => {
  const { statuses, quantities } = props;
  const labels = mapStatuses(statuses, quantities);
  return (
    <Label.Group style={{ display: "inline-block" }}>
      {labels.map((label) => {
        return (
          <Label
            as={Button}
            color={label.color}
            disabled={props.disabled}
            basic={label.disabled}
            className="clickable"
            onClick={() => props.onClick(label.key)}
            style={{ border: "1px solid" }}
          >
            {label.text}
            <Label.Detail>{label.quantity || 0}</Label.Detail>
          </Label>
        );
      })}
    </Label.Group>
  );
};

export default StatusLabels;
